import { useState } from 'react';
import { Link } from '@mui/material';
import { Popover } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateWorkItem } from 'queries';
import { FileText } from 'ts-react-feather-icons';

import { Button } from 'common/button';

import EstateWorkItemEstateCellDetails from './estate-work-items-estate-cell-details';

const useStyles = makeStyles(() => ({
  stackedDataFirst: {
    display: 'block',
    lineHeight: '1.43',
    width: '100%',
  },
  stackedData: {
    display: 'block',
    lineHeight: '1.43',
    paddingTop: 5,
  },
  link: {
    paddingTop: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  popoverContent: {
    padding: 15,
  },
  estateDetailTitle: {
    paddingTop: 5,
    fontWeight: 'bold',
  },
}));

type EstateWorkItemEstateCellProps = {
  estateWorkItem: EstateWorkItem;
  handleImpersonateView: (type: string, estateWorkItem: EstateWorkItem) => void;
};

const EstateWorkItemEstateCell = ({
  estateWorkItem,
  handleImpersonateView,
}: EstateWorkItemEstateCellProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const estate = estateWorkItem.estate!;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div>
      <div className={classes.stackedDataFirst}>
        <Link
          className={classes.link}
          onClick={() => handleImpersonateView('estate', estateWorkItem)}
        >
          {estate.estateName}
        </Link>
        <div className={classes.stackedData}>
          <Link
            className={classes.link}
            onClick={() => handleImpersonateView('documents', estateWorkItem)}
          >
            <FileText /> Vault
          </Link>
        </div>
        <div className={classes.stackedData}>
          <Button id={estateWorkItem.id} size="tiny" onClick={handleClick}>
            details
          </Button>
        </div>
      </div>
      {open && (
        <Popover
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          onClose={handleClose}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <div className={classes.popoverContent}>
            <EstateWorkItemEstateCellDetails
              estateWorkItem={estateWorkItem}
              handleImpersonateView={handleImpersonateView}
            />
          </div>
        </Popover>
      )}
    </div>
  );
};

export default EstateWorkItemEstateCell;
